import { Impression } from '@lib/iab/iab-vast-model';

interface IImpression {
    id: string;
    _value: string;
}

const createImpression = ($impression: IImpression): Impression => {
    const impression = new Impression();
    impression.id = $impression.id;
    impression.uri = $impression._value;
    return impression;
};

export default createImpression;
